<!-- 订单下面的表格组件 -->
<template>
    <div class="order">
      <div style="display: flex;align-items: center;flex: 1;">
        <div style="display: flex;">
          <div style="width: 350px;">
            <span class="titleClass">商品信息</span>
          </div>
          <div style="width: 80px;">
            <span class="titleClass">单价（元）</span>
          </div>
          <div style="width: 120px;">
            <span class="titleClass">数量</span>
          </div>
          <div style="width: 120px;">
            <span class="titleClass">商品操作</span>
          </div>
        </div>
        <div style="display: flex;flex: 1;">
          <div style=" display: flex;flex: 1;">
            <span class="titleClass">收货信息</span>
          </div>
          <div style="display: flex;flex: 1;">
            <span class="titleClass">物流信息</span>
          </div>
          <div style="width: 120px;">
            <span class="titleClass">操作</span>
          </div>
        </div>
      </div>
      <el-divider></el-divider>
      <div v-for="propsrow, row in tableData" :key="row"
        style="display: flex;flex: 1;border-radius: 4px;margin: 10px 0px;flex-direction: column;overflow: hidden;border-left: 1px solid #EBEEF5;border-right: 1px solid #EBEEF5;border-bottom:  1px solid #EBEEF5;">
        <div
          style="background-color: #EDF6F6;width: 100%;display: flex;align-items: center;padding: 10px 12px;position: relative;">
          <div class="item" />
          <span class="descText"> 创建时间：</span>
          <span class="descText">{{ propsrow.orderTime }}</span>
          <span class="marrinLeft">{{ propsrow.status == '1' ? '应付总额：' : '实付总额：' }} </span>
          <span class="descText">￥{{ propsrow.copeAmount }} </span>
          <span class="marrinLeft">
            {{ routerType == "procument" ? "商户" : "用户" }}：</span>
          <span class="descText">
            {{
              routerType == "procument"
              ? propsrow.payeeShopName
              : propsrow.payShopName
            }}
          </span>
          <span class="marrinLeft">订单号：</span>
          <span class="descText">{{propsrow.orderCode}}</span>
          <span class="lastStatus" style="margin-left: auto;">
            <div>
              <el-image class="icon_status" :src="getStatus(1, propsrow.status)" style="height: 20px; width: 20px" />
              <span class="descText" :class="getStatus(3, propsrow.status)">{{
                getStatus(2, propsrow.status)
              }}</span>
            </div>
          </span>
        </div>
        <div style="display: flex;flex: 1;align-items: center;">
          <div style="display: flex;flex-direction: column;">
            <div v-for="(item, index) in propsrow.orderDetailVo" :key="index">
              <div style="display: flex;flex: 1;align-items: center;">
                <div class="thClass columnFlex" style="width: 350px;border-right: 1px solid #EBEEF5;">
                  <div class="imageBox">
                    <el-image style="width: 80px; height: 80px" :src="item.image || avater" />
                    <div>
                      <p class="name">{{ item.name }}</p>
                      <p class="duanluo pihao">{{ item.approvalNumber }}</p>
                      <p class="duanluo">{{ item.factory }}</p>
                      <p class="duanluo">{{ item.specification }}</p>
                    </div>
                  </div>
                  <div>
                    <div v-for="(giftTtem, giftIndex) in item.giftGoodsList" :key="giftIndex" class="inLine">
                      <GiftTag />
                      <span class="inLineName">{{ giftTtem.name }}</span>
                      <span class="inLineQty">x{{ giftTtem.qty }}</span>
                    </div>
                  </div>
                </div>
                <div class="thClass" style="width: 80px;">
                  <div style="display: flex;flex: 1;justify-content: center;align-items: center;">
                    <p v-if="routerType == 'procument'" class="duanluo">
                      ￥{{ item.price }}
                    </p>
                    <p v-else class="duanluo">
                      ￥{{ item.servicePrice || item.price }}
                    </p>
                  </div>
                </div>
                <div class="thClass" style="width: 120px;">
                  <div style="display: flex;flex: 1;justify-content: center;flex-direction: column;">
                    <p class="duanluo" :class="item.shipmentsAmount != item.qty ? 'titleRed' : ''">发货量：{{
                      item.shipmentsAmount
                      || '0'
                    }}</p>
                    <p class="duanluo" v-if="item.shipmentsAmount != item.qty"
                      :class="item.shipmentsAmount != item.qty ? 'titleRed' : ''">需求量：{{ item.qty }}</p>
                  </div>
                </div>
                <div class="thClass" style="width: 120px;">
                  <div class="submit" style="display: ;flex: 1;justify-content: center;align-items: center;">
                    <el-link v-if="routerType == 'procument'"
                      :disabled="true"
                      :underline="false" type="primary" class="btn" @click="applyService(item, 'APPLY_FOR')">申请售后</el-link>
  
                    <el-link v-else style="color: #595959 !important" :disabled="true" :underline="false" type="primary" class="btn"
                      @click="cancelSale(item, 'CANCEL_SALE')">发起退货</el-link>
                    <div style="font-size: 14px;font-weight: 400;color: #595959 !important;">
                      {{ btnStr(propsrow.invoiceAfterSaleStatus) ? `发票售后` + btnStr(propsrow.invoiceAfterSaleStatus) : '' }}
                    </div>
                    <div style="font-size: 14px;font-weight: 400;color: #595959 !important;">
                      {{ btnStr(propsrow.certificationStatus) ? `资质售后` + btnStr(propsrow.certificationStatus) : '' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <tr style="display: flex;flex: 1;">
            <th class="thClass" style="text-align: left; display: flex;flex: 1;padding-left: 12px;"
              :style="{ 'height': propsrow.orderDetailVo.length * lineHeight + 'px' }">
              <div style="display: flex;flex: 1;flex-direction: column;justify-content: center;">
                <p v-if="propsrow.erpShopCode" class="duanluo">
                  ERP编码：{{ propsrow.erpShopCode }}</p>
                <p class="duanluo" v-if="propsrow.orderDetailVo[0].contactsName">{{ propsrow.orderDetailVo[0].contactsName
                }}</p>
                <p class="duanluo" v-if="propsrow.orderDetailVo[0].contactsPhone">{{ propsrow.orderDetailVo[0].contactsPhone
                }}</p>
                <p class="duanluo" v-if="propsrow.orderDetailVo[0].address">{{ propsrow.orderDetailVo[0].address }}</p>
              </div>
            </th>
            <th class="thClass" style="text-align: left; display: flex;flex: 1;"
              :style="{ 'height': propsrow.orderDetailVo.length * lineHeight + 'px' }">
              <div style="padding-left: 12px;">
                <p class="duanluo">
                  {{ propsrow.orderDetailVo[0].expressTime }}
                </p>
                <p class="duanluo">{{ propsrow.orderDetailVo[0].expressStatus }}</p>
                <p class="duanluo txt-line-2">{{ propsrow.orderDetailVo[0].expressDesc }}</p>
              </div>
            </th>
            <th class="thClass" style="width: 120px;"
              :style="{ 'height': propsrow.orderDetailVo.length * lineHeight + 'px' }">
              <div class="submit"
                style="display: flex;justify-content: center;align-items: center;flex-direction: column;flex: 1;">
                <el-link :underline="false" type="primary" class="btn" @click="
                  goDetail(propsrow)
                  ">订单详情</el-link>
              </div>
            </th>
          </tr>
  
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { buttonView } from '@/api/externalSalesRule/index'
  import ElImageViewer from "element-ui/packages/image/src/image-viewer";
  import { checkStatus } from "@/utils/status";
  import avater from "/public/img/default.png";
  import { certificationStatusStr } from "@/utils/certificationStatus";
  import GiftTag from '@/components/giftTag/index.vue'
  export default {
    components: { ElImageViewer, GiftTag,  },
    props: {
      loading: {
        type: Boolean,
        default: false,
      },
      tableData: {
        type: Array,
        default: () => {
          return [];
        },
      },
      routerType: {
        type: String,
        default: "sale",
      },
    },
    data () {
      return {
        deliverControl: '', // 发货控制
        showViewer: false,
        url: "",
        avater: avater,
        dialogFormErp: { erpShopCode: "", payShopId: null, payeeShopId: "" },
        visibleErp: false,
        lineHeight: 180,
      };
    },
    computed: {
      getStatus () {
        return (type, status) => checkStatus(type, status);
      },
    },
    watch: {},
    methods: {
    
      btnStr (status) {
        // console.log(certificationStatusStr[status], 'certificationStatusStr[status]')
        return certificationStatusStr[status] || ''
      },
     
      // 根据商户查询数据权限判断前端按钮展示
      buttonView () {
        buttonView().then(res => {
          if (res) {
            this.deliverControl = res.deliverControl
          }
        })
      },
    
        goDetail (row) {
        this.$router.push({
            path: '/business/businessManage-order-detail',
            query: { id: row.id, orderId: row.orderId }
        })
        },
    },
    created () {
      this.buttonView()
    },
    mounted () { },
    beforeCreate () { },
    beforeMount () { },
    beforeUpdate () { },
    updated () { },
    beforeDestroy () { },
    destroyed () { },
    activated () { },
  };
  </script>
  <style lang="scss" scoped>
  .order {
    display: flex;
    flex-direction: column;
    flex: 1;
  
    ::v-deep tbody {
      tr :first-child {
        th {
          padding: 10px 0;
        }
      }
    }
  
    .inLine {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #595959;
      margin: 5px 12px;
      font-weight: 400;
  
      .inLineName {
        margin-left: 5px;
      }
  
      .inLineQty {
        margin-left: 10px;
      }
    }
  }
  
  // ::v-deep .el-table__expanded-cell {
  //   padding: 0px 0px;
  // }
  
  .builtinTableClass {
    width: 100%;
    border-color: #ebeef5;
  }
  
  .titleClass {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #262626;
    height: 35px;
  }
  
  .thClass {
    text-align: center;
    height: 180px;
    display: flex;
    border-right: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
    align-items: center;
  
    // padding: 5px 0px;
  
    div {
      color: #8c8c8c !important;
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
    }
  
    .submit {
      text-align: center !important;
    }
  
    .btn {
      display: block;
      padding: 5px 0;
    }
  
    .titleRed {
      color: var(--main-color);
    }
  }
  
  .columnFlex {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-items: flex-start;
  }
  
  .qulificationText {
    padding-left: 12px;
    text-align: left;
    display: flex;
    align-items: center;
  }
  
  .remarkText {
    padding-left: 26px;
    text-align: left;
    line-height: 2;
    width: 350px;
  }
  
  .imageBox {
    display: flex;
    align-items: center;
    margin-left: 12px;
  
    .name {
      margin: 7px 0;
      color: #262626;
    }
  
    .pihao {
      color: #595959;
    }
  
    .el-image {
      padding: 0px !important;
    }
  }
  
  .duanluo {
    margin: 3px;
    font-weight: 400;
    color: #595959;
    font-size: 14px;
  
    .detail {
      float: right;
    }
  }
  
  .lastStatus {
    float: right;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  
  ::v-deep .el-table--enable-row-transition .el-table__body td.el-table__cell {
    background: #edf6f6;
    // padding: 10px 10px;
    // border-radius: 4px;
    border-bottom: none;
  }
  
  ::v-deep .el-table--enable-row-transition .el-table__body td.el-table__expanded-cell {
    background: #fff;
    padding: 0 0 10px 0;
  }
  
  ::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__expanded-cell {
    background: #fff !important;
  }
  
  .el-table tr:hover {
    background: #fff !important;
  }
  
  .el-table td.el-table__cell div {
    // color: white;
    text-align: left;
  }
  
  ::v-deep .el-table tbody tr:hover>td {
    background: #edf6f6 !important;
  }
  
  .icon_status {
    height: 20px;
    width: 20px;
    vertical-align: top;
  }
  
  .text {
    margin-left: 10px;
  }
  
  .yellow {
    color: #f99b0d;
  }
  
  .green {
    color: #32bf78;
  }
  
  .gray {
    color: #8c8c8c;
  }
  
  .marrinLeft {
    margin-left: 16px;
    font-size: 14px;
    color: #595959;
  }
  
  .descText {
    font-size: 14px;
    color: #595959;
  }
  
  ::v-deep .el-table__body-wrapper .el-table__row td.el-table__cell {
    border-radius: 10px 10px 0 0;
  }
  
  ::v-deep .el-table th.el-table__cell.is-leaf {
    // border: none;
  }
  
  ::v-deep .el-table__row.expanded {
    // margin-bottom: 20px;
  }
  
  ::v-deep .el-table__body {
    margin-top: 10px;
  }
  
  .toolTip {
    width: 40vw;
  }
  </style>
  